import { Box, Flex, Button, useDisclosure, IconButton, Stack, Container } from '@chakra-ui/react';
import { Menu, X } from 'lucide-react';
import { useState, useEffect } from 'react';

const Header = () => {
  const { isOpen, onToggle } = useDisclosure();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const MenuItems = () => (
    <>
      {['Home', 'Products', 'Features', 'About', 'Investors', 'Careers', 'Funding', 'Contact'].map(
        (item) => (
          <Button
            key={item}
            variant='ghost'
            color='brand.light'
            width={{ base: 'full', md: 'auto' }}
            _hover={{ color: 'brand.accent' }}
            onClick={() => {
              const element = document.getElementById(item.toLowerCase());
              element?.scrollIntoView({ behavior: 'smooth' });
              if (isOpen) onToggle();
            }}>
            {item}
          </Button>
        )
      )}
    </>
  );

  return (
    <Box
      position='fixed'
      top='0'
      left='0'
      right='0'
      zIndex='1000'
      transition='all 0.3s'
      bg={scrolled ? 'rgba(2, 8, 20, 0.95)' : 'transparent'}
      backdropFilter={scrolled ? 'blur(10px)' : 'none'}>
      <Container maxW='1200px'>
        <Flex
          minH={{ base: '50px', md: '60px' }}
          py={{ base: 3, md: 2 }}
          px={4}
          align='center'
          justify='space-between'>
          <Flex align='center'>
            <Box
              fontSize={{ base: 'xl', md: '2xl' }}
              fontWeight='bold'
              color='brand.accent'
              letterSpacing='wider'>
              GallifreyAI
            </Box>
          </Flex>

          <Flex display={{ base: 'none', md: 'flex' }}>
            <MenuItems />
          </Flex>

          <IconButton
            display={{ base: 'flex', md: 'none' }}
            onClick={onToggle}
            icon={isOpen ? <X /> : <Menu />}
            variant='ghost'
            aria-label='Toggle Navigation'
            color='brand.light'
            size='lg'
          />
        </Flex>

        <Box
          display={{ base: isOpen ? 'block' : 'none', md: 'none' }}
          pb={4}
          bg='rgba(2, 8, 20, 0.95)'
          backdropFilter='blur(10px)'>
          <Stack as='nav' spacing={2} p={4}>
            <MenuItems />
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Header;
